import * as React from 'react'
import loadable from '@loadable/component'

import { useTheme } from '@thg-commerce/gravity-elements/theme'

import { StoreOpeningTime } from '../../StoreSearch/types'

import { StoreStatusWrapper, StyledText } from './styles'

const StatusIcon = loadable(
  () => import('@thg-commerce/gravity-icons/src/components/StoreStatus'),
)
export enum Status {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  PERMANENTLY_CLOSED = 'PERMANENTLY_CLOSED',
  TEMPORARILY_CLOSED = 'TEMPORARILY_CLOSED',
}

interface StoreStatusProps {
  openingTimes?: StoreOpeningTime
  status?: Status
  isOpen?: boolean
  i18n?: {
    storeOpenText?: string
    storeClosedText?: string
    storeTempClosed?: string
    storePermClosed?: string
    storeDetailsButton?: string
    getDirectionsButton?: string
  }
}

export const formatTime = (dateString: string) => {
  const formattedData = dateString
    .replace('.', ':')
    .split(':')
    .map((part) => part.trim())

  let hour = parseInt(formattedData[0], 10)

  if (hour < 10) {
    hour = parseInt(`${0}${hour}`, 10)
  }

  const minute = formattedData[1]

  return `${hour}:${minute}`
}

export const StoreStatus = ({
  openingTimes,
  status,
  i18n,
  isOpen,
}: StoreStatusProps) => {
  const theme = useTheme()

  if (status === Status.PERMANENTLY_CLOSED) {
    return (
      <StoreStatusWrapper>
        <StatusIcon fill={theme.colors.error.base} />
        <StyledText>{i18n?.storePermClosed}</StyledText>
      </StoreStatusWrapper>
    )
  }
  if (status === Status.TEMPORARILY_CLOSED) {
    return (
      <StoreStatusWrapper>
        <StatusIcon fill={theme.colors.error.base} />
        <StyledText>{i18n?.storeTempClosed}</StyledText>
      </StoreStatusWrapper>
    )
  }

  if (isOpen) {
    return (
      <StoreStatusWrapper>
        <StatusIcon fill={theme.colors.success.base} />
        {openingTimes && (
          <StyledText>{`${i18n?.storeOpenText} ${formatTime(
            openingTimes?.openingTime,
          )} - ${formatTime(openingTimes?.closingTime)}`}</StyledText>
        )}
      </StoreStatusWrapper>
    )
  }
  return (
    <StoreStatusWrapper>
      <StatusIcon fill={theme.colors.error.base} />
      <StyledText>{i18n?.storeClosedText}</StyledText>
    </StoreStatusWrapper>
  )
}
